import { CapacitorHttp, HttpOptions, HttpResponse } from "@capacitor/core";
import baseHttpOptions from "../../util/http-common";

const getTraineesV1015 = async (group: string, sort: string, masterTrainer: number) => {
  /* Extended ist die alte report-data-list-for-trainer-v2 */
  let url: string = `report-data-list-for-trainer-extended-v1-0-15?group=${group}&sort=${sort}&master_trainer=${masterTrainer}`;

  const options: HttpOptions = await baseHttpOptions(url);
  const response: HttpResponse = await CapacitorHttp.get(options);

  const { data } = response;
  //console.log(data)
  return data;
};

const getTraineesWithOpenEntriesV1015 = async (masterTrainer?: number) => {
  let url: string = `report-data-list-for-trainer-v1-0-15${masterTrainer ? `?master_trainer=${masterTrainer}` : ''}`;

  const options: HttpOptions = await baseHttpOptions(url);
  const response: HttpResponse = await CapacitorHttp.get(options);

  const { data } = response;
  //console.log(data)
  return data;
};

const TraineeService = {
  getGroupedAndSortedTrainees: getTraineesV1015,
  getTrainees: getTraineesWithOpenEntriesV1015
};

export default TraineeService;
